import styled from "styled-components";
import Button from "../Button";
import { tokens, media } from "../../../design/tokens";

/*
 * Item do carrinho — SOMENTE ESTILO, o index.tsx nao foi tocado. Todos os
 * ganchos de classe que ele usa continuam aqui (.container2, .image,
 * .overlay2, .courseContent, .whitecolor, .nameWithCoupon, .oldPrice,
 * .valorcartaoparcelado, .discount).
 *
 * O arquivo inteiro estava escrito para o painel branco que o carrinho tinha
 * ate agora: `color: black`, divisoria `#ebebeb`, cinzas de tema claro.
 */
export const FlexContainer = styled.div`
  a {
    text-decoration: none;
  }

  color: ${tokens.color.textWhite};

  border-bottom: solid 1px ${tokens.color.fieldSlate};

  &:last-child {
    border-bottom: 0;
  }
`;

export const Container = styled.div`
  /* Ancora do posicionamento da lixeira — ver .overlay2 abaixo. */
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${tokens.space.md};

  border-radius: ${tokens.radius.xs};
  /* A faixa a direita e a pista exclusiva da lixeira: sem ela o texto do
     preco correria por baixo do botao. */
  padding: ${tokens.space.md} 48px ${tokens.space.md} 0;

  transition: width 0.4s, height 0.4s;

  width: 100%;
  height: auto;
  min-height: 100px;

  /* position: static de proposito: assim o ancestral posicionado do
     .overlay2 passa a ser o Container, e a lixeira sai de cima da capa. */
  .container2 {
    position: static;
    width: 30%;
    max-width: 120px;
    flex-shrink: 0;

    ${media.upTo(tokens.breakpoint.sm)} {
      max-width: 90px;
    }
  }

  .image {
    display: block;
    width: 100%;
    height: auto;
  }

  /*
   * A lixeira ficava sobreposta a capa do curso, tapando a arte e competindo
   * com ela. Como o botao esta dentro do wrapper da imagem no JSX (e o
   * index.tsx nao e tocado neste trabalho), a saida e mudar o ancestral
   * posicionado: com .container2 estatico, este absolute passa a se resolver
   * contra o Container e o botao vai para a pista propria a direita.
   */
  .overlay2 {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);

    bottom: auto;
    width: auto;
    padding: 0;
    text-align: initial;

    opacity: 1;
    color: ${tokens.color.textWhite};
    font-size: initial;
  }

  p {
    font-size: ${tokens.font.body.size};
    font-family: ${tokens.font.body.family};

    margin-top: ${tokens.space.sm};
  }

  /* Era largura fixa em 65%, que somada aos 30% da capa e ao gap nao fechava
     100% — sobrava folga irregular a direita. Ocupando o que resta, o bloco
     de preco encosta na propria pista, nao numa medida arbitraria. */
  .courseContent {
    flex: 1;
    min-width: 0;

    ${media.upTo(tokens.breakpoint.sm)} {
      display: flex;
      margin-left: 10px;
      flex-direction: column;

      & > div {
        display: flex;
        flex-direction: row;
        align-items: end;

        .whitecolor {
          color: ${tokens.color.textWhite};
        }
      }
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Thumb = styled.img`
  object-fit: cover;

  box-shadow: ${tokens.shadow.imageSeat};
  border: 0;
  border-radius: ${tokens.radius.xs};

  width: 120px;
  height: 68px;

  ${media.upTo(tokens.breakpoint.sm)} {
    img {
      width: 90px;
      height: 48px;
    }
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${tokens.space.sm};

  color: ${tokens.color.textWhite};

  p {
    margin: 0;
  }

  /*
   * Quem cede espaco e o titulo, nunca o preco. Sem isto, um titulo mais
   * longo espremia a coluna de valores e os numeros quebravam no meio
   * ("R$ 177,30 no / pix"), que e a forma mais rapida de um preco parecer
   * errado.
   */
  span {
    text-align: right;
    margin: 0;

    flex-shrink: 0;
    white-space: nowrap;
  }

  > p,
  .nameWithCoupon {
    min-width: 0;
    overflow: hidden;
  }

  .nameWithCoupon {
    display: flex;
    flex-direction: column;

    > strong {
      font-size: ${tokens.font.caption.size};
      color: ${tokens.color.textAsh};
    }
  }

  .oldPrice {
    color: ${tokens.color.textAsh};
    text-decoration: line-through;
  }

  .valorcartaoparcelado {
    color: ${tokens.color.textAsh};
    font-size: ${tokens.font.caption.size};
  }

  /* Era verde #00b431 — terceiro acento, proibido pela Regra da Voz Unica. */
  .discount {
    color: ${tokens.color.marqueeGold};
    font-size: ${tokens.font.caption.size};
    font-weight: 600;
  }
`;

/*
 * Remover item.
 *
 * Era `background: red` puro — vermelho cheio, do tamanho de um selo, colado
 * na capa do curso. Vermelho no sistema e o canal de ERRO (#c53030 em borda
 * de campo invalido), nao o de "remover": gritava mais que o proprio preco.
 * Vira um controle discreto que so assume o vermelho semantico no hover,
 * quando a intencao de apagar ja existe.
 */
export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  padding: 0;
  flex-shrink: 0;

  border-radius: ${tokens.radius.xs};

  background: transparent;
  border: 1px solid ${tokens.color.fieldSlate};
  color: ${tokens.color.textAsh};

  transition: color 0.2s, border-color 0.2s, background 0.2s;

  &:hover {
    background: rgba(197, 48, 48, 0.14);
    border-color: ${tokens.color.errorRed};
    color: ${tokens.color.errorRed};
  }

  svg {
    color: currentColor;
  }

  p {
    display: none;
  }

  ${media.upTo(1200)} {
    width: 32px;
    height: 32px;

    p {
      display: none;
    }

    svg {
      font-weight: bold;
    }
  }
`;
